<div class="alerts-form-input-wrapper align-right">
  <app-switch-button
    [switchButtonConfiguration]="alertsConfigCreateNewConfiguration.statusAlertConfigSwitchButtonConfiguration"
    [switchButtonModel]="state.alertActivationSwitchButtonModel"
    (switch)="formInputValueHandlerActive($event,AlertsCreateNewInputEnum.ACTIVE)"
  data-cy="alert-status-switch"></app-switch-button>
</div>

<div class="alerts-form-name-toggle-wrapper">
  <div class="alerts-form-input-wrapper">
    <app-input-text #alertNameInput
      (inputStateChange)="manageAlertNameInputStateChange($event)"
      (inputValueChange)="formInputValueHandlerText($event, AlertsCreateNewInputEnum.NAME)"
      [maxLength]="40"
      [messages]="alertNameInputMessages"
      [warningLevel]="WarningEnum.WARNING_APPLY"
      [alternateBackground]="true"
      [initialValue]="$safeNavigationMigration(editAlertConfig?.editAlertConfigData?.name)"
      [showViewMode]="isViewMode"
      baseCypressTag="alerts-create-new-form-input-name"
      label="Alert name"
    placeholder="Insert alert name"></app-input-text>
  </div>
</div>

<div class="alerts-form-input-content-wrapper">
  <app-input-textarea #alertContentInput
    (inputStateChange)="manageAlertContentInputStateChange($event)"
    (inputValueChange)="formInputValueHandlerText($event,AlertsCreateNewInputEnum.DESCRIPTION)"
    [maxLength]="400"
    [height]="112"
    [messages]="alertContentInputMessages"
    [warningLevel]="WarningEnum.WARNING_APPLY"
    [alternateBackground]="true"
    [initialValue]="$safeNavigationMigration(editAlertConfig?.editAlertConfigData?.description)"
    [showViewMode]="isViewMode"
    baseCypressTag="alerts-create-new-form-input-description"
    label="Alert content"
  placeholder="Insert an alert content"></app-input-textarea>
</div>

<div class="alert-status-switch-wrapper">
  <app-switch-button
    [switchButtonConfiguration]="alertsConfigCreateNewConfiguration.scheduleAlertConfigSwitchButtonConfiguration"
    [switchButtonModel]="state.alertScheduleActivationSwitchButtonModel"
    (switch)="switchAlertScheduleActivation($event)"
  data-cy="alert-status-switch"></app-switch-button>
  <app-tooltip [dynamic]=false [message]="alertsConfigCreateNewConfiguration.timeZoneTooltipInfo"><span
  class="iwp-icon-gen_info_info icon-info"></span></app-tooltip>
</div>
@if (showInputDatetimepickers()) {
  <div class="alert-form-schedule-dates-wrapper">
    <div class="alert-form-schedule-date">
      <app-input-datepicker
        #scheduleStartDateInput
        (inputStateChange)="manageScheduleStartDateInputStateChange($event)"
        (closedDatepicker)="formInputValueHandlerDate($event, AlertsCreateNewInputEnum.SCHEDULE_STARTS_ON)"
        (inputValueChange)="onDatePickerValueChange($event, AlertsCreateNewInputEnum.SCHEDULE_STARTS_ON)"
        [alternateBackground]="true"
        [isDisabled]="state.scheduleDateInputsDisabled"
        [messages]="scheduleStartDateInputMessages"
        [warningLevel]="startDateWarningLevel"
        [validators]="validators.scheduleStartDate"
        [minDate]="state.minScheduleStartDate"
        [timezone]="alertsConfigCreateNewConfiguration.timeZone"
        [dayTemplateData]="state.minScheduleStartDate"
        [initialValue]="state.startDateNgbDate"
        [showViewMode]="isViewMode"
        label="Start date"
        baseCypressTag="alert-create-schedule-date-start">
      </app-input-datepicker>
    </div>
    @if (!isViewMode) {
      <span class="schedule-date-text-separator">to</span>
    }
    <div class="alert-form-schedule-date">
      <app-input-datepicker
        #scheduleEndDateInput
        (inputStateChange)="manageScheduleEndDateInputStateChange($event)"
        (closedDatepicker)="formInputValueHandlerDate($event, AlertsCreateNewInputEnum.SCHEDULE_ENDS_ON)"
        (inputValueChange)="onDatePickerValueChange($event, AlertsCreateNewInputEnum.SCHEDULE_ENDS_ON)"
        [alternateBackground]="true"
        [isDisabled]="state.scheduleDateInputsDisabled"
        [messages]="scheduleEndDateInputMessages"
        [validators]="validators.scheduleEndDate"
        [minDate]="state.minScheduleEndDate"
        [timezone]="alertsConfigCreateNewConfiguration.timeZone"
        [dayTemplateData]="state.minScheduleEndDate"
        [initialValue]="state.endDateNgbDate"
        [showViewMode]="isViewMode"
        label="End date"
        baseCypressTag="alert-create-schedule-date-end">
      </app-input-datepicker>
    </div>
  </div>
}
